import { Loader } from 'lucide-react';

import { cn } from '../../../shadcn/lib/utils';

interface LoadingSpinnerProps {
  readonly className?: string;
}

export function LoadingSpinner({ className }: LoadingSpinnerProps) {
  return (
    <div className={cn('flex h-full min-h-0 w-full flex-1 items-center justify-center bg-transparent', className)}>
      <Loader className={'w-12 h-12 animate-spin text-[var(--color-primary-500)]'} />
    </div>
  );
}
